"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.assist.attachKnowledge': 'Adjuntar Conocimiento:',
    'ai.assist.knowledgeFound': 'Conocimiento relevante encontrado',
    'ai.assist.relevantKnowledgeFound': 'Conocimiento relevante encontrado después de la conversación',
    'ai.assist.attachmentIds': 'IDs de adjuntos',
};
